// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"MN-z","carouselContainer":"NN-z"};